import { gql } from '@apollo/client';

export const ALL_AUCTIONEER_DATA_TEMPLATES_QUERY_NAME = 'AllAuctioneerDataTemplates';
export const ALL_AUCTIONEER_DATA_TEMPLATES = gql`
    query ${ALL_AUCTIONEER_DATA_TEMPLATES_QUERY_NAME}(
    $page: Int,
    $perPage: Int,
    $sortKey: String,
    $sortDirection: String,
    ) {
        allAuctioneerDataTemplates(
            page: $page,
            perPage: $perPage,
            sortKey: $sortKey,
            sortDirection: $sortDirection,
        ) {
            availableAuctioneers {
                memberId
                name
            }
            availableSubmarkets {
                code
                name
            }
            maxQuantitySum
            auctioneerDataTemplateList {
                totalCount
                models {
                    id
                    name
                    templateItems {
                        auctioneer {
                            memberId
                            name
                        }
                        submarket {
                            code
                            name
                        }
                        quantity
                    }
                }
            }
        }
    }
`;

export const CREATE_AUCTIONEER_DATA_TEMPLATE = gql`
    mutation CreateAuctioneerDataTemplate(
        $name: String!,
        $templateItems: [AuctioneerDataItemInputInput],
        $correlationId: String!
    ) {
        createAuctioneerDataTemplate(
            name: $name,
            templateItems: $templateItems,
            correlationId: $correlationId
        ) {
            name
        }
    }
`;

export const UPDATE_AUCTIONEER_DATA_TEMPLATE = gql`
    mutation UpdateAuctioneerDataTemplate(
        $id: Int!,
        $name: String!,
        $templateItems: [AuctioneerDataItemInputInput],
        $correlationId: String!
    ) {
        updateAuctioneerDataTemplate(
            id: $id,
            name: $name,
            templateItems: $templateItems,
            correlationId: $correlationId
        ) {
            name
        }
    }
`;

export const DELETE_AUCTIONEER_DATA_TEMPLATE = gql`
    mutation DeleteAuctioneerDataTemplate(
        $id: Int!, 
        $correlationId: String!
    ) {
        deleteAuctioneerDataTemplate(
            id: $id, 
            correlationId: $correlationId
        ) {
            name
        }
    }
`;

export const ON_AUCTIONEER_DATA_TEMPLATE_CHANGE = gql`
subscription onAuctioneerDataTemplateChanged {
        auctioneerDataTemplateChanged {
            correlationId
            action
            model {
                name
            }
        }
    }
`;
